import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { i18n } from './i18n';
import './assets/css/main.css';
import { VueMaskDirective } from 'v-mask'; // Importa la directiva específica

const app = createApp(App);

app.use(router);
app.use(i18n);

// En lugar de .use(VueMask), regístrala como directiva
app.directive('mask', VueMaskDirective);

app.mount("#app");